// Tiny helper for recording recently-viewed broadcasts to localStorage.
// The MyPage reads this list back and displays it under "최근 본 방송".
const KEY = 'livemoa_recent_broadcasts';
const MAX = 20;

export const recordRecentBroadcast = (live) => {
  if (!live || !live.schedule_id) return;
  try {
    const prev = JSON.parse(localStorage.getItem(KEY) || '[]');
    const trimmed = prev.filter((b) => b.schedule_id !== live.schedule_id);
    trimmed.unshift({
      schedule_id: live.schedule_id,
      seller_id: live.seller_id,
      seller_name: live.seller_name,
      title: live.title,
      thumbnail: live.thumbnail,
      platform: live.platform,
      viewed_at: new Date().toISOString()
    });
    localStorage.setItem(KEY, JSON.stringify(trimmed.slice(0, MAX)));
  } catch (e) {
    // localStorage may be disabled; silently ignore
  }
};
